module.exports = __webpack_public_path__ + "static/media/mail-and-parcels.4e30838a.jpeg";